import React from 'react';
import PropTypes from 'prop-types';

import {MotifImageIcFlashOn24px} from '@ey-xd/motif-icon';

import OutputText from '@ey/canvascoreservices/OutputText';
import Icon from '@ey/canvascoreservices/Icon';

import StyledRiskType from './StyledRiskType';
import {riskTypeAbbreviation} from '../../../util/uiconstants';

const RiskTypeAbbreviationDisplay = ({id = null, className = ''}) => {
	if (!id) return false;

	const renderIcon = () => {
		const props = {
			src: MotifImageIcFlashOn24px,
			className: className
		};

		return <Icon {...props} />;
	};

	const renderAbbreviation = () => <OutputText body2>{riskTypeAbbreviation[id]}</OutputText>;

	return (
		<StyledRiskType className={className}>
			{renderIcon()}
			{renderAbbreviation()}
		</StyledRiskType>
	);
};

RiskTypeAbbreviationDisplay.propTypes = {
	id: PropTypes.oneOf([1, 2, 3])
};

export default RiskTypeAbbreviationDisplay;
